// Peliryhmän "Kopioi aikataulu": vie palvelimen valmiiksi renderöimän aikataulun leikepöydälle pelkkänä tekstinä
// (CopyScheduleButton, src/routes/public/results.tsx). Nappi näytetään vain, kun leikepöytä on käytettävissä.
export function setupCopySchedule(): void {
  if (!navigator.clipboard) return;
  for (const btn of document.querySelectorAll<HTMLButtonElement>("button[data-copy-schedule]")) {
    const text = btn.dataset.copySchedule ?? "";
    const label = btn.textContent ?? "";
    const status = document.createElement("span");
    status.className = "sr-only";
    status.setAttribute("role", "status");
    // insertBefore: Workers-tyypitys varjostaa DOM:n after()-metodin.
    btn.parentNode?.insertBefore(status, btn.nextSibling);
    let timer = 0;
    const flash = (text: string) => {
      btn.textContent = text;
      status.textContent = text;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        btn.textContent = label;
        status.textContent = "";
      }, 2500);
    };
    btn.hidden = false;
    btn.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(text);
        flash(btn.dataset.labelDone ?? label);
      } catch {
        flash(btn.dataset.labelFailed ?? label);
      }
    });
  }
}
